import { QuestionGroupPartialData } from '@new/pools/pool/lib/utils/get-modal-data/question-group-partial-data';
import { PoolLabelFragment } from '../services/pool/load-pool.generated';

export const updateLabels = (
  allLabels: PoolLabelFragment[],
  currentLabels: QuestionGroupPartialData['labels'],
  labelIdsToAdd: string[],
  labelIdsToRemove: string[]
): QuestionGroupPartialData['labels'] => {
  const currentLabelIds = currentLabels.map(label => label.id);
  const updatedLabelIds = new Set(currentLabelIds);

  labelIdsToAdd.forEach(idToAdd => updatedLabelIds.add(idToAdd));
  labelIdsToRemove.forEach(idToRemove => updatedLabelIds.delete(idToRemove));

  return allLabels.filter(label => updatedLabelIds.has(label.id));
};
